import React from 'react';
import { func, object } from 'prop-types';
import classNames from 'classnames';
import { noop } from 'lodash';
import { I18n } from '@fiverr-private/fiverr_context';
import { MP_CLICKED_COMPARE_PACKAGES } from '../../../../../utils/mixPanelEvents';

import './style.scss';

const CompareBtn = ({ onComparePackagesClick = noop }, { biEvents }) => {

    const onClick = (event) => {
        event.preventDefault();

        biEvents.sendMixPanelEvent({ eventName: MP_CLICKED_COMPARE_PACKAGES });

        onComparePackagesClick();
    };

    return (
        <button className={classNames('btn-compare-packages', 'tbody-6')}
            onClick={onClick}>
            <I18n k={'gig_page_perseus.packages_tabs.compare_packages'}/>
        </button>
    );
};

CompareBtn.propTypes = {
    onComparePackagesClick: func
};

CompareBtn.contextTypes = {
    biEvents: object
};

export default CompareBtn;
